// extracted by mini-css-extract-plugin
export default {"popup":"_3Xvf1wPB44RN57aXt1OR4M","btnMargin":"_21Q4Dwq519JyXnnlnZHmOh","close":"_3GXEZ7bmYfdnb7jETiRt9S","crossBtn":"_33IOSZA_mAbEzy36X4LiS_"};